import { useDrClearCareEstimate } from 'lib/hooks/queries/useDrClearCareEstimate';

import ReceiptModal from 'components/shared/Receipt/ReceiptModal';
import CheckinPreviewInvoice from 'components/Patient/checkin/SecurePayment/components/CheckinPreviewInvoice/CheckinPreviewInvoice';
import DrClearCareModal from 'components/Patient/checkin/SecurePayment/components/CheckinPreviewInvoice/DrClearCare/DrClearCareModal';
import CheckinGoodFaithEstimate from 'components/Patient/checkin/SecurePayment/components/CheckinGoodFaithEstimate/CheckinGoodFaithEstimate';

import { DOCUMENT_IDS, invoiceIdFromDocumentId } from '../lib/constants';

const DocumentPreviewModals = ({
  previewId,
  onClose,
  appointment,
  invoice: invoiceProp,
  invoices = [],
  transactionId,
  surchargeAmount,
  token,
  channels,
  isAppointmentLoading = false,
  isAppointmentError = false,
  onRetryAppointment
}) => {
  const isDrClearCareOpen = previewId === DOCUMENT_IDS.DR_CLEAR_CARE;
  const previewedInvoiceId = invoiceIdFromDocumentId(previewId);
  const previewedInvoice = previewedInvoiceId
    ? invoices.find((item) => String(item?.id) === String(previewedInvoiceId))
    : null;
  const invoice = previewedInvoice || invoiceProp || appointment?.invoice;

  const {
    estimate,
    isFetching: isEstimateFetching,
    isError: isEstimateError,
    refetch: refetchEstimate
  } = useDrClearCareEstimate({
    appointmentId: appointment?.id,
    invoice,
    enabled: isDrClearCareOpen
  });

  return (
    <>
      <ReceiptModal
        isOpen={previewId === DOCUMENT_IDS.RECEIPT}
        onClose={onClose}
        transactionId={transactionId}
        appointmentId={appointment?.id}
        token={token}
        isPatient
      />
      <CheckinGoodFaithEstimate
        isOpen={
          previewId === DOCUMENT_IDS.GOOD_FAITH_ESTIMATE ||
          previewId === DOCUMENT_IDS.GFE_PAYMENT_OPTIONS
        }
        onClose={onClose}
        appointmentId={appointment?.id}
        practice={appointment?.practice}
        patient={appointment?.patient}
        procedures={invoice?.procedures}
        channels={channels}
      />
      <CheckinPreviewInvoice
        isOpen={previewId === DOCUMENT_IDS.INVOICE || !!previewedInvoiceId}
        onClose={onClose}
        invoice={invoice}
        practice={appointment?.practice}
        surchargeAmount={surchargeAmount}
      />
      <DrClearCareModal
        isOpen={isDrClearCareOpen}
        onClose={onClose}
        estimate={estimate}
        isLoading={isEstimateFetching || isAppointmentLoading}
        isError={isEstimateError || isAppointmentError}
        onRetry={isAppointmentError ? onRetryAppointment : refetchEstimate}
        practice={appointment?.practice}
        appointmentId={appointment?.id}
        channels={channels}
      />
    </>
  );
};

export default DocumentPreviewModals;
